import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DEACTIVATECARD = gql`
  mutation setCardDeactivate($id: ID!) {
    setCardDeactivate(id: $id)
  }
`;
function DeactivateCard({ id, name, children, onDeactivateCard }) {
    const [runDeactivateCard, setDeactivateCard] = useMutation(DEACTIVATECARD, {
        onCompleted({ setCardDeactivate }) {
          if (setCardDeactivate) {
            message.success(`کارت کاربر ${name ? name : ""} غیرفعال شد.`);
            onDeactivateCard();
          } else {
            message.error("متاسفانه مشکلی پیش آمده!کارت کاربر غیرفعال نشد.");
          }
        },
        onError() {
          message.error("متاسفانه مشکلی پیش آمده!کارت کاربر غیرفعال نشد.");
        },
      });
      const doDeactivateCard = () => {
        runDeactivateCard({
          variables: { id },
        });
      };
    return (
        <>
        <Popconfirm
          title={`غیرفعال کردن ${name ? "کارت " + name : "کارت کاربر"}?`}
          okText="غیرفعال کردن"
          cancelText="خیر"
          onConfirm={doDeactivateCard}
        >
          <span>{children}</span>
        </Popconfirm>
      </>
    );
}

export default DeactivateCard;